// extracted by mini-css-extract-plugin
export default {"levels_container":"LevelsPage_levels_container__l0Axr","divider":"LevelsPage_divider__Xh5DJ","categories_container":"LevelsPage_categories_container__n2p4j"};